import React from 'react';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../../../../constants/text';
import { colors } from '../../../../../constants/colors';

const Root = styled.div.withConfig({ componentId: 'sc-zd5ywg-0' })`
  font-family: ${fontFamily.book};
  font-size: 15px;
  color: ${colors.fadeToBlack};
  line-height: 16px;
  display: flex;
  justify-content: space-between;
  margin: 25px 4px 10px 0;
`;

type Props = {
  title: string;
};

const SectionTitle = ({ title }: Props) => <Root>{title}</Root>;

export default SectionTitle;
